module.exports = __webpack_public_path__ + "static/media/burst-mode.6a726a7e.svg";